import React, {useEffect, forwardRef, useImperativeHandle} from "react";
import "./style.scss";
export const QuestionnaireSelect = ({list, clickNext, value}) => {
    return <div className={'questionnaire-select'}>
        <div className={'questionnaire-select-title'}>
            {list?.title}
        </div>
        <div className={'questionnaire-select-list'}>
            {list.list?.map((item, index) => {
                return <div className={`questionnaire-select-item ${value === item?.value || value === item?.content  ? "questionnaire-select-item-select" : ""}`} onClick={() => {clickNext(item?.value || item.content)}} key={index}>
                    <div className={'questionnaire-select-item-content'}>
                        {item.content}
                    </div>
                    {item?.subcontent &&<div className={'questionnaire-select-item-sub-content'}>
                        {item?.subcontent}
                    </div>}
                </div>
            })}
        </div>
    </div>;
};

QuestionnaireSelect.propTypes = {};
